<script>
    // ================= Props =================
    export let stage = "progress";
    export let total = 0;
    export let done = 0;
    export let errors = 0;
    export let label = "";
    export let sticky = true;
    export let showErrors = true;

    // ================= Reactive =================
    $: pct = (total > 0) ? Math.min(100, Math.max(0, (done / total) * 100)) : 0;
    $: indeterminate = (total <= 0) && (stage === "creating" || stage === "saving" || stage === "progress" || stage === "adding");
    function defaultLabel({stage, done, total, label}) {
        if (label) return label;
        const hasCount = total > 0;
        switch (stage) {
            case "creating": return "Creando campaña…";
            case "adding": return hasCount ? `Agregando jugadores ${done}/${total}…` : "Agregando jugadores…";
            case "saving": return "Guardando…";
            case "done": return "Completado ✅";
            case "warning": return "Completado con errores";
            case "error": return "Ocurrió un error";
            default: return hasCount ? `Procesando ${done}/${total}…` : "Procesando…";
        }
    }
    $: labelText = defaultLabel({ stage, done, total, label });
</script>

<div
        class="pbanner stage-{stage} {sticky ? 'sticky' : ''} {indeterminate ? 'is-indeterminate' : 'is-determinate'}"
        role="progressbar"
        aria-valuemin={indeterminate ? null : 0}
        aria-valuemax={indeterminate ? null : 100}
        aria-valuenow={indeterminate ? null : Math.round(pct)}
        aria-live="polite"
>
    <div class="track"></div>
    {#if indeterminate}
        <div class="fill indet"></div>
    {:else}
        <div class="fill" style="width:{pct}%;"></div>
    {/if}
    <div class="content">
        <span class="label">{labelText}</span>
        {#if showErrors && errors > 0}
            <span class="errors"> · {errors} error{errors !== 1 ? 'es' : ''}</span>
        {/if}
    </div>
</div>

<style>
    .pbanner{
        flex: 0 0 auto;
        position: relative;
        width: 100%;
        height: var(--pbanner-h, 28px);
        border-radius: 10px;
        overflow: hidden;
        margin: .5rem 0 .75rem 0;
        box-shadow: 0 2px 10px rgba(0,0,0,.06);
    }
    .pbanner.sticky{ position: sticky; top: 0; z-index: 2; }

    .track{
        position: absolute; inset: 0;
        background: #f2f3f5; /* pista neutra */
    }
    .fill{
        position: absolute; top:0; left:0; bottom:0;
        background: linear-gradient(0deg, rgba(46,93,255,1) 0%, rgba(46,93,255,.9) 100%);
        transition: width .25s ease;
    }
    .pbanner.stage-warning .fill{
        background: #ffc107;
    }
    .pbanner.stage-error .fill{
        background: #dc3545;
    }
    .fill.indet{
        width: 35%;
        animation: slide 1.2s infinite linear;
    }
    @keyframes slide{
        0%   { transform: translateX(-100%); }
        100% { transform: translateX(300%); }
    }
    .content{
        position: relative;
        height: 100%;
        display: flex; align-items: center; justify-content: center;
        font-weight: 600; letter-spacing: .2px;
        color: #fff;
        mix-blend-mode: normal;
        text-shadow: 0 1px 2px rgba(0,0,0,.35);
    }
    .pbanner:not(:has(.fill[style*="width:"])) .content,
    .pbanner:has(.fill.indet) .content {
        color: #222;
        text-shadow: none;
    }
    .errors{ font-weight: 500; opacity: .9; }
    .pbanner.stage-warning .content{
        color: #3d3000;
        text-shadow: none;
    }
</style>
